import { Component, OnInit, Input } from '@angular/core';
import { Member } from '@asambleas-models/member.model';
import { GeneralService } from '@asambleas-services/general/general.service';
import { MinisterService } from '@asambleas-services/minister/minister.service';
import { MatDialog } from '@angular/material';
import { Minister } from '@asambleas-models/minister.model';
import { UserFeedbackService } from '@asambleas-modules/user-feedback/user-feedback.service';

import { LoaderComponent } from '@asambleas-components/loader/loader.component';
import { AlertComponent } from '@asambleas-components/alert/alert.component';
import { UserFormModalComponent } from '@asambleas-components/modals/user-form-modal/user-form-modal.component';
import { EditMinisterComponent } from '@asambleas-components/modals/edit-minister/edit-minister.component';
import { RolesService } from '@asambleas-services/roles/roles.service';

import { DISTRITAL_DIRECTOR_ROLE } from '../../config/data';
import { ConfirmComponent } from '@asambleas-components/confirm/confirm.component';
import { CredentialRenovation } from '@asambleas-models/CredentialRenovation';


@Component({
  selector: 'app-member-page',
  templateUrl: './member-page.component.html',
  styleUrls: ['./member-page.component.scss']
})
export class MemberPageComponent implements OnInit {

  @Input('member') member: Member;
  @Input('ministerButtons') ministerButtons: boolean = true;

  minister: Minister = null;
  isLoggedUser: boolean = false;

  /* MANEJO DE IMAGENES */
  selectedFile: File = null;
  imagenTemp: any = null;
  cambiarImagen: boolean = false;
  canUpload: boolean = false;

  distritalDirectorId: number = 0;

  canRenovateCredential: boolean = false;
  credentialRenovationStatus: string;
  credentialRenovationDescription: string;

  constructor(
    public generalService: GeneralService,
    private ministerService: MinisterService,
    public rolesService: RolesService,
    private _dialog: MatDialog,
    private _feedback: UserFeedbackService) { }

  ngOnInit() {
    this.distritalDirectorId = DISTRITAL_DIRECTOR_ROLE;

    if (JSON.parse(localStorage.getItem('user')).id == (this.member ? this.member.id : null)) {
      this.isLoggedUser = true;
    }

    this.getMinisterData();
  }

  getMinisterData() {
    this.ministerService.getMinisterByUserId(Number(this.member.id))
      .subscribe((data: Minister) => {
        if (data) {
          this.minister = data;

          if (this.shouldRenovateCredential()) {

            this.ministerService.statusRequestCredentialRenovation({ minister_id: this.minister.id, expiry_credential_date: this.minister.expiry_date_credential })
              .subscribe((response: any) => {  // EL RETORNO PUEDE SER INVALID O EL OBJETO DE LA SOLICITUD DE RENOVACION

                if (response.invalid) {  // NO POSEE UNA SOLICITUD DE RENOVACIÓN PARA LA FECHA DE EXPIRACION DE LA CREDENCIAL
                  this.canRenovateCredential = true;
                }
                else { // TIENE UNA SOLICITUD, POR ENDE SE MUESTRA EL ESTADO
                  this.credentialRenovationStatus = response.status;
                  this.credentialRenovationDescription = response.description;
                }

              }, (error) => {
                console.log('Hubo un error', error);
              })
          }
        }
      }, (error) => {
        console.error('No es ministro');
      });
  }

  onFileChanged(event) {

    if ((event.target.files[0].type).indexOf('image') < 0) {
      return;
    }

    this.selectedFile = event.target.files[0];


    let reader = new FileReader();
    let urlImagenTemp = reader.readAsDataURL(this.selectedFile);

    reader.onloadend = () => {
      this.imagenTemp = reader.result;
    }

    this.canUpload = true;

  }

  uploadImage() {

    const loader = this._dialog.open(LoaderComponent);

    const uploadData = new FormData();

    uploadData.append("file", this.selectedFile);
    uploadData.append('user_id', JSON.parse(localStorage.getItem('user')).id);


    this.generalService.uploadAvatarToUser(uploadData)
      .subscribe((data: { message: 'string', path: 'string', user: any }) => {
        loader.close();

        localStorage.setItem('user', JSON.stringify(data.user));

        this.canUpload = false;
        this.cambiarImagen = false;

        this._dialog.open(AlertComponent, {
          width: '35vw',
          disableClose: true,
          data: {
            title: 'Felicitaciones',
            content: "Su avatar fue modificado correctamente"
          }
        })

      }, (error) => {
        loader.close();

        console.log(error);
        this.canUpload = true;

        this._dialog.open(AlertComponent, {
          width: '35vw',
          disableClose: true,
          data: {
            title: 'Lo sentimos',
            content: "Hubo un problema al intentar subir su avatar"
          }
        })
      })

  }

  editPersonalInformationModal() {
    let dialog = this._dialog.open(UserFormModalComponent, {
      disableClose: true,
      data: { member: this.member }
    })
    dialog.afterClosed().subscribe((resp) => {
      //console.log(resp)
      if (resp) {
        // Si el envio fue exitoso, entonces muestro un modal de edición exitosa
        if (resp.success) {
          this._feedback.openDialog({ title: 'Exito', body: 'Los datos se han actualizado de manera correcta' })
        } else {
          this._feedback.openDialog({ title: 'Lo sentimos', body: resp.message + ' - ' + resp.error })
        }
      }
    })
  }

  editMinister() {
    let dialog = this._dialog.open(EditMinisterComponent, {
      disableClose: true,
      data: { minister: JSON.parse(JSON.stringify(this.minister)) },
      width: '800px'
    })

    dialog.afterClosed().subscribe((resp) => {
      if (resp) {
        if (resp.success) {
          this.getMinisterData();

          this._feedback.openDialog({ title: 'Exito', body: 'Los datos se han actualizado de manera correcta' })
        } else {
          this._feedback.openDialog({ title: 'Lo sentimos', body: resp.message + ' - ' + resp.error })
        }
      }
    })
  }

  shouldRenovateCredential(): boolean {

    if (!this.minister.expiry_date_credential) {

      return false;
    }

    let expiryDate: Date = new Date(this.minister.expiry_date_credential.replace('/', '/01/'));
    //let expiryDate: Date = new Date('02/18/2019'); // FECHA AUXILIAR PARA PROBAR EL METODO
    let today: Date = new Date();

    let difference: number = Math.abs(expiryDate.getTime() - today.getTime());  // DIFERENCIA EN MILISEGUNDOS ENTRE LA FECHA DE EXPIRACIÓN Y HOY

    const monthsLimit: number = 4;  //VARIABLE PARA DETERMINAR CUANTOS MESES ES EL LIMITE PARA ACTIVAR EL BOTON
    let remainingLimit: number = 1000 * 3600 * 24 * 30 * monthsLimit;  // CONVERSIÓN DE MESES A MILISEGUNDOS

    //console.log(`Diferencia ${difference}, en días: ${difference / (1000 * 3600 * 24)}`);

    if (difference <= remainingLimit) {
      return true;
    }
    else {
      return false;
    }
  }

  renovateCredential() {
    const ref = this._dialog.open(ConfirmComponent, { data: { title: 'Renovar credencial', content: '¿Está seguro de solicitar la renovación de su credencial?', btnAgree: 'Renovar', btnDisagree: 'Cancelar' } });

    ref.afterClosed().subscribe((response: { return: boolean }) => {
      if (response.return) {
        console.log('RENOVAR');

        this.ministerService.requestCredentialRenovation({ minister_id: this.minister.id, expiry_credential_date: this.minister.expiry_date_credential })
          .subscribe((data: CredentialRenovation) => {
            console.log('SERVIDOR', data);
            this.credentialRenovationStatus = data.status;
            this.canRenovateCredential = false;

          }, (error) => {
            console.log('Hubo un error');
          })

      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/components/member-page/member-page.component.ts